import React, { Suspense } from 'react';

export default function EsperarComponente(Component) {
  return (props) => (
    <Suspense fallback={<div>Carregando...</div>}>
      {} <Component {...props} />
    </Suspense>
  );
}
